import { AlertsChartPeriod } from './enums';

export const getTimePeriodInDays = (timePeriod: string): number => {
  switch (timePeriod) {
    case AlertsChartPeriod.LAST_WEEK:
      return 7;
    case AlertsChartPeriod.LAST_MONTH:
      return 31;
    case AlertsChartPeriod.LAST_THREE_MONTHS:
      return 91;
    default:
      return 0;
  }
};
